module.exports = __webpack_public_path__ + "img/P150T_weapon_158.9c1c7846.png";